import React from 'react';
import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  card: {
    position: 'relative',
    border: '1px solid #fff',
    minHeight: "270px",
  },
  center: {
    textAlign: 'center',
  },
  imgIco: {
    width: 30,
  },
  title: {
    fontSize: 25,
    color: '#000',
    marginTop: 15,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  titleEmpty: {
    fontSize: 25,
    marginTop: 15,
    marginBottom: 16,
  },

  automaticDebitIcon: {
    width: 25,
  },
  IndicatorIcon: {
    width: 25,
    alignSelf: 'center',
    display: 'flex',
  },
  automaticDebitIconModal: {
    width: 16,
    marginRight: 5,
  },
  quota: {
    margin: 0,
    paddingLeft: 7,
  },
  quotaTitle: {
    fontWeight: 500,
  },
  quotaDate: {
    fontSize: 13,
    paddingTop: 4,
  },
  price: {
    fontWeight: 'bold',
    color: '#000',
  },
  descriptionDebit: {
    fontSize: 14,
    margin: 0,
    color: 'rgba(0, 0, 0, 0.54)',
  },
  rootHiddenDebt: {
    padding: '16px',
    backgroundColor: 'lightGray',
    opacity: '70%',
  },
  divHiddenIcon: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  imgHidden: {
    width: '130px',
    height: '130px',
    position: 'absolute',
  },
  stampContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

const useStampClases =  makeStyles({
  root: {
    position: "absolute",
    top: '-8px',
    padding: '10px 20px',
    fontWeight: 'bold',
    color: ({ color }) => color,
    background: 'rgba(255,255,255,0.5)',
    border: '4px solid',
    borderColor: ({ color }) => color,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    transform: 'rotate(-15deg)',
  }
})

export const Stamp = ({ label, color }) =>  {
  const classes = useStampClases({ color });

  return (
    <div className={classes.root}>
      {label}
    </div>
  );
}
